"use client";
import ICMWrapper from "@/app/components/icm-wrapper";
import HeroSection from "./components/hero-section";
import BlogsSection from "@/app/components/blogs-section";
// import Offerings from "./components/offerings";
// import BondsandFD from "./components/bondsandfd";
// import ExploreDiverseInvestment from "./components/exploreDiverseInvestment";
// import Hero from "@/app/components/Hero";
import WhyICM1 from "@/app/assets/images/why-icm-1.png";
import WhyICM2 from "@/app/assets/images/why-icm-2.png";
import WhyICM3 from "@/app/assets/images/why-icm-3.png";
// import Banner from "@/app/components/banner";
import Navbar from "@/app/components/header";
import { useEffect, useState } from "react";
// import { clearRedirectTo } from "./utils/helper";
import { AMZ_VOUCHER, ANNOUNCEMENT_TRIGGER_SCREENS } from "./utils/constants";
import { FCM } from "./interface/homepage";
import Link from "next/link";
import { staticNavLinks, authLinks } from "@/config/nav-links";
import { InvestmentOptions } from "./interface/platform";
import UEHero from "./unlisted-shares/components/ue-hero";
// import { useCleverTapEvents } from "@/app/hooks/use-clevertap";
import WhyUnlistedShares from "@/app/unlisted-shares/components/why-unlisted";
// import ReferAndEarn from "./unlisted-shares/components/refer-&-earn";
import { useAuth } from "@/context/authcontext";
import InvestmentOpportunities from "./unlisted-shares/components/investment-opportunities";
import dynamic from "next/dynamic";

const WhyICM = dynamic(() => import("@/app/components/why-icm"));
const Testimonial = dynamic(() => import("@/app/components/testimonial"));
const HowToInvest = dynamic(() => import("@/app/unlisted-shares/components/how-to-invest"));
const ReferAndEarnPrelogin = dynamic(
    () => import("./unlisted-shares/components/refer-&-earn-prelogin"),
);
const Faq = dynamic(() => import("@/app/components/faq"));
const ComingSoon = dynamic(() => import("./unlisted-shares/components/coming-soon"));
const InvestJourney = dynamic(() => import("@/app/components/invest-journey"));
const Footer = dynamic(() =>
    import("@/app/components/footer").then((mod) => ({ default: mod.Footer })),
);
const FCMInit = dynamic(() => import("./components/fcm-init"), { ssr: false });
const AnnouncementDialog = dynamic(
    () =>
        import("./components/popup/announcement").then((mod) => ({
            default: mod.AnnouncementDialog,
        })),
    { ssr: false },
);

export default function Home() {
    const { isAuthenticated, isLoading } = useAuth();
    const [message, setmessage] = useState<FCM>();
    const [renderAnnouncement, setrenderAnnouncement] = useState<boolean>(false);
    const [, setactive] = useState("refer");
    // const { cleverTapTrackEvent } = useCleverTapEvents();

    // const handleCleverTapTest = () => {
    //     cleverTapTrackEvent("Custom Event", {
    //         screen: "Home",
    //         buttonName: "Custom Event",
    //         timestamp: new Date().toISOString(),
    //     });
    // };

    const data = [
        {
            id: 1,
            title: "Invest from just 1 share",
            img: WhyICM1,
            content: "Start small and build your portfolio at your own pace.",
        },
        {
            id: 2,
            title: "No hidden costs",
            img: WhyICM2,
            content: "Simple, transparent pricing with no surprise charges.",
        },
        {
            id: 3,
            title: "Guidance at every step",
            img: WhyICM3,
            content:
                "Access research, insights, and dedicated support throughout your investment journey.",
        },
    ];

    /* useEffect(() => {
        // Clear redirectTo on fresh load
        clearRedirectTo();
    }, []); */

    useEffect(() => {
        if (message) {
            setrenderAnnouncement(true);
        }
    }, [message]);

    return (
        <>
            {/* SEO-friendly static navigation - rendered server-side */}
            <nav
                className="sr-only"
                aria-label="Site navigation"
                itemScope
                itemType="https://schema.org/SiteNavigationElement"
            >
                <ul>
                    {staticNavLinks.map((item) => (
                        <li key={item.label} itemProp="name">
                            <Link href={item.href} itemProp="url">
                                {item.label}
                            </Link>
                        </li>
                    ))}
                    {authLinks.map((item) => (
                        <li key={item.label} itemProp="name">
                            <Link href={item.href} itemProp="url">
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>

            {isAuthenticated && <FCMInit setMessage={setmessage} />}
            {message?.triggerScreen === ANNOUNCEMENT_TRIGGER_SCREENS.HomeScreen &&
                renderAnnouncement && (
                    <AnnouncementDialog
                        renderAnnouncement={renderAnnouncement}
                        setrenderAnnouncement={setrenderAnnouncement}
                        data={message}
                    />
                )}

            {/* <Banner /> */}

            <Navbar active={InvestmentOptions.Home} />

            <div className="bg-[#F4F4F7]">
                <ICMWrapper>
                    <HeroSection
                        description="Discover opportunities beyond traditional stock exchanges. Invest in India's unlisted and pre-IPO companies before they go public and participate in their long-term growth journey."
                        btn1Label="Get Started"
                    />
                </ICMWrapper>
            </div>

            <ICMWrapper>
                <UEHero redirectTo={`${process.env.ICM_UE_URL}/login`} initialData={null} />
            </ICMWrapper>

            <WhyUnlistedShares />

            <InvestmentOpportunities />

            <div className="bg-[#F4F4F7] md:p-s2">
                <ICMWrapper>
                    <WhyICM title="" data={data} />
                </ICMWrapper>
            </div>

            <ICMWrapper>
                {/* <div className="mt-10 md:mt-10"></div> */}
                <Testimonial
                    redirectTo={`${process.env.ICM_UE_POST_URL}/login`}
                    btnName="Start Investing"
                    eventName="US_Listing_Page_Start_Investing_Fold_3"
                />
            </ICMWrapper>

            <HowToInvest />

            {/* <Hero />
            <BondsandFD /> */}
            {/* <ExploreDiverseInvestment /> */}

            {/* <Offerings /> */}

            <ReferAndEarnPrelogin
                active="Refer"
                setactive={setactive}
                isAuthenticated={isAuthenticated}
                authLoading={isLoading}
                footerText={""}
                voucherAmt={AMZ_VOUCHER}
            />

            <Faq
                bgColor="bg-[#F4F4F7]"
                compact={false}
                product="unlistedEquities"
                subProduct="generic"
            />

            <ICMWrapper>
                <ComingSoon initialData={null} />
            </ICMWrapper>

            <BlogsSection page={InvestmentOptions.Home} />

            {/* <Subscribe /> */}
            <InvestJourney />
            <Footer active={InvestmentOptions.Home} />
        </>
    );
}
